import makeStyles from '@mui/styles/makeStyles';
import { isDark } from 'global/styles';
import colors from 'global/styles/colors';

const useStyles = makeStyles((theme) => ({
  container: {},
  buttonContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),

    '& button': {
      margin: theme.spacing(1),
      marginBottom: 0,
    },
  },
  opHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  opTitle: {
    fontSize: 20,
    color: theme.palette.text.primary,
    fontWeight: '500',
    marginLeft: theme.spacing(1),
  },

  list: {
    '& div > li': {
      backgroundColor: theme.palette.action.disabledBackground,
      marginBottom: 3,
      borderLeft: (p) => `3px solid ${p.color}`,

      '& .MuiIcon-root,.MuiSvgIcon-root': {
        color: isDark(theme) ? theme.colors.white : theme.colors.blue,
        cursor: 'pointer',
        marginLeft: theme.spacing(1),

        '&.arrowIcon': {
          color: colors.grey,
        },
      },
    },
  },
  collapseContainer: {
    padding: theme.spacing(2),
  },
  title: {
    fontSize: 14,
    fontWeight: 'bold',
  },
  listItem: {
    '@media print': {
      pageBreakAfter: 'always !important',
    },
    '& .iconContainer': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  box: {
    width: '100%',
    marginBottom: theme.spacing(4),
    float: 'left',
    clear: 'both',
  },
  innerHtml: {
    boxSizing: 'border-box',
  },
  innerHasImage: {
    width: (p) => (p.printView ? '100%' : '50%'),
    float: 'left',
    [theme.breakpoints.down('md')]: {
      width: '100% !important',
    },
  },
  imagesContainer: {
    boxSizing: 'border-box',
    paddingLeft: (p) => (p.printView ? 0 : theme.spacing(2)),
    paddingRight: (p) => (p.printView ? 0 : theme.spacing(2)),
    float: (p) => (p.printView ? undefined : 'right'),
    width: (p) => (p.printView ? '100%' : '50%'),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'top',
    flexWrap: 'wrap',

    '& .IMAGE': {
      marginRight: 3,
      marginBottom: 3,
      cursor: 'pointer',
    },
    [theme.breakpoints.down('md')]: {
      width: '100% !important',
    },
  },

  createTopContent: {
    display: 'inline-block',

    '& .imgContainer': {
      float: 'left',
      width: '100%',
      paddingLeft: 0,
      paddingRight: 0,
    },
    '& .innerHtml': {
      width: '100%',
    },
  },

  showMore: {
    cursor: 'pointer',
  },
}));

export default useStyles;
